import React, { Fragment, memo } from 'react';
import T from 'prop-types';
import { FontIcon, Input, Separator } from '../../../../ReusableComponents';
import { colors, rs } from '../../../../../styles';
import Title from './Title';
import { Box, TitleContainer } from './styles';
import strings from '../../../../../localization';

const PriceInTokensInput = memo(({ value, onFocus, onChangeText, tokenName }) => (
  <Fragment>
    <Box>
      {/*<Title mandatory>{strings.items.price_in_tokens.replace('XXX', tokenName)}</Title>*/}
      <Input
        style={rs.paddingVertical}
        keyboardType="numeric"
        onChangeText={onChangeText}
        value={value}
        onFocus={onFocus}
        underlineColorAndroid="transparent"
        placeholder={strings.items.price_placeholder}
      />
    </Box>
  </Fragment>
));

PriceInTokensInput.propTypes = {
  value: T.string,
  onFocus: T.func,
  onChangeText: T.func,
  tokenName: T.string,
};

export default PriceInTokensInput;
